module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-site-768x591.01a2d61c.jpg";